module.exports = __webpack_public_path__ + "h5/img/question.c7aed7e4.png";